import * as React from 'react';
import { Box, Container } from '@chakra-ui/react';
import dynamic from 'next/dynamic';
import remarkGfm from 'remark-gfm';
import ChakraUIRenderer from '@/components/legal/ChakraUIRenderer';
import { Footer } from '@/components/chakraUIPro/Footer';
import Page from '@/components/Page';
import { termsMarkDownText } from '@/data/terms';

const Markdown = dynamic(() => import('react-markdown'), { ssr: false });

const Terms = () => (
  <Page
    seoOptions={{
      title: 'Terms and conditions| eezi',
      description: '',
      canonical: 'https://eezi.io/terms/'
    }}
    maxW='100%'
    showNav
    p={0}
    m={0}
  >
    <Container pt={{ base: '8', lg: '8' }} pb={{ base: '12', lg: '24' }} maxWidth='8xl'>
      <Markdown remarkPlugins={[remarkGfm]} components={ChakraUIRenderer()} skipHtml>
        {termsMarkDownText}
      </Markdown>
    </Container>

    {/* Footer */}
    <Box>
      <Box maxW='8xl' mx='auto' px={8} textAlign='left'>
        <Footer />
      </Box>
    </Box>
  </Page>
);

export default Terms;
